import { useState } from "react";
import { Header } from "semantic-ui-react";
import { Radio } from "antd";
import { IModalProps } from "../../InterfaceProp";

const TabEvaluato =({datos,userState, changeState, handleObservacion, observacionData}: IModalProps)=> {

    const [check, setCheck] = useState({
        checked: true
    }) 
   const handleChange = ( e: any) =>{
        setCheck({
            checked: e.target.value

        })
        changeState(check)
    } 

        return (
            <>
                    <Header size="small">
                        {/* Comentarios evaluador de jurados {datos.first_name}{" "}
                        {datos.middle_name} {datos.first_surname} {datos.second_surname} */}
                    </Header>

                    <div className="form">
                    <div style={{display: 'flex', width: '100%', justifyContent:'center'}} className="descripcion-del-jurado">
                        <textarea value={observacionData ? observacionData : ""} onChange={e => handleObservacion(e.target.value)} style={{width: '100%', height:'200px'}} />
                    </div>
                        {!userState && (
                            <>
                            <div>
                                ¿Cumple con los requisitos para ser jurado?
                            </div>
                            <div style={{ display: "flex" }}>


                                <span>Si</span>

                            <Radio
                            type="Radio"
                            value={false}
                            checked={check.checked === false}
                            onChange={handleChange}/>

                            <span>No</span>
                                <Radio
                            type="Radio"
                            value={true}
                            checked={check.checked}
                            onChange={handleChange}/>


                            </div>
                            </>
                        )}
                    </div>

            </>
        );
    };

export default TabEvaluato